import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';
import SubPage from '#/common/components/SubPage';
import useTenantQuery from '../hooks/useTenantQuery';
import TenantForm from '../components/TenantForm/TenantForm';
import getFormTitle from '#/common/utils/getFormTitle';

export interface TenantParams {
  readonly id?: string;
}

const TenantPage: React.FC = () => {
  const { id } = useParams() as TenantParams;
  const tenantQuery = useTenantQuery(id);
  const tenant = tenantQuery.data?.getTenant?.data;

  // Use a ref to store the initial updatedAt value to prevent form remount
  // on background refetches (cache-and-network).
  const formKeyRef = useRef<string | null>(null);
  if (tenant && !formKeyRef.current) {
    formKeyRef.current = tenant.updatedAt ?? tenant.id ?? null;
  }

  const name = tenant?.name;
  const title = getFormTitle(id, name, 'Organization');
  return (
    <SubPage title={title} isLoading={tenantQuery.loading} showGoBackButton type="form">
      {tenant && (
        <TenantForm key={`tenant-${id}-${formKeyRef.current}`} tenant={tenant} title={title} />
      )}
    </SubPage>
  );
};

export default React.memo(TenantPage);
